module.exports = __webpack_public_path__ + "assets/img/00053.d403a80d.png";